import { dew as _unitDew } from "../../constants/unit.js";
import { dew as _parseUnitsDew } from "./parseUnits.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.parseGwei = void 0;
  const unit_js_1 = _unitDew();
  const parseUnits_js_1 = _parseUnitsDew();
  function parseGwei(ether, unit = "wei") {
    return (0, parseUnits_js_1.parseUnits)(ether, unit_js_1.gweiUnits[unit]);
  }
  exports.parseGwei = parseGwei;
  //# sourceMappingURL=parseGwei.js.map
  return exports;
}